import React from 'react';
import { TrendingCell } from './TrendingCell';
import { AudioPlayer } from './AudioPlayer';
const jsmediatags = window.jsmediatags

const arr = [
    'https://github.com/liljdot/test/raw/main/04.%20No%20Option.mp3',
    'https://github.com/liljdot/test/raw/main/Jon%20Bellion%20-%20Run%20Wild%20-%20BaseShare.com.mp3',
    'https://github.com/liljdot/test/raw/main/All%20The%20Stars%20-4216871-102-.mp3',
    'https://github.com/liljdot/test/raw/main/12.%20Congratulations%20(Ft.%20Quavo).mp3',
    'https://github.com/liljdot/test/raw/main/Heat.mp3'

]


export function Aside() {
    const [library, setLibrary] = React.useState([])
    const [track, setTrack] = React.useState('')
    const [trends, setTrends] = React.useState([])
    const [mostPlayed, setMostPlayed] = React.useState([])
    const [forcedIsPlaying, setForcedIsPlaying] = React.useState(false)
    React.useEffect(() => {
        arr.forEach(song => {
            const proxy = 'https://cors-anywhere.herokuapp.com/'
            const file = proxy+song
            jsmediatags.read(file, {
                onSuccess: tag => {
                    const data = tag.tags.picture.data
                    const format = tag.tags.picture.format
                    let base64String = ''
                    for (let i=0; i<data.length; i++) {
                     base64String += String.fromCharCode(data[i])
                 }
                    setLibrary(prev => [...prev, {
                        url: song,
                        songName: tag.tags.title,
                        artist: tag.tags.artist,
                        albumArt: `data:${format};base64,${window.btoa(base64String)}`
                    }])
                    console.log(library)
                    if (library.length === 1) { setTrack(library[0]) }
                },
                onError: error => console.log(error)
            })
            
        })
    }, [])

    const changeTrack = (e) => {
        console.log(e.target.id)
          if (track.url !== e.target.id) {
            const newTrack = library.find(song => song.url === e.target.id)
            console.log('newTrack')
              setTrack(newTrack)
              setForcedIsPlaying(true)
              console.log('target.key.songName')
          }
    }

    const forcePause = () => {
        setForcedIsPlaying(false)
      }
    return (
        <aside>
            <div></div>
            <div>
                <h3 id='aside-title'>Most Played</h3>
                <div class='aside-section'>
                    <div class='art-square' style={{ backgroundColor: 'blue' }} ></div>
                    <div class='art-square' style={{ backgroundColor: 'blue' }} ></div>
                    <div class='art-square' style={{ backgroundColor: 'blue' }} ></div>
                </div>
            </div>
            <div>
                <h3 id='aside-title'>Trending</h3>
                {!library.length > 0 ? <div class='trend-section'>
                    <TrendingCell />
                    <TrendingCell />
                    <TrendingCell />
                    <TrendingCell />
                    <TrendingCell />
                    <TrendingCell />
    <TrendingCell />
                    {/*library.map(item => <TrendingCell track = {item} onClick = {changeTrack} />)*/}
                </div> : <div class = 'trend-section'>{library.map(item => <TrendingCell track = {item} onClick = {changeTrack} />)}</div>}
            </div>
            <div>
                {track ? <AudioPlayer track = {track} forcedIsPlaying = {forcedIsPlaying} forcePause = {forcePause} /> : <AudioPlayer></AudioPlayer>}
            </div>
        </aside>
    )
}